import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import { motion } from 'motion/react'
import { BtnsHoverAnimation } from '../../utils/animation'

const MotionBox = motion.create(Box)
const LinkBtn = ({
  name, to, disabled, customStyle, ...props
}) => (
 <MotionBox
    component={Link}
    sx={[styles.greenBtn, customStyle]}
    to={to}
    disabled={disabled}
    variants={BtnsHoverAnimation}
    whileHover={!disabled && 'hover'}
    {...props}
  >
    {name}
  </MotionBox>
)

const styles = {
  greenBtn: {
    width: '100%',
    height: '40px !important',
    color: 'white',
    backgroundColor: '#29cc8b',
    boxShadow: 'none',
    textTransform: 'capitalize',
    minWidth: { xs: '140px', sm: '160px' },
    borderRadius: '10px',
    padding: { xs: '0px', sm: '7px 10px' },
    textDecoration: 'none',
    textAlign: 'center',
    maxWidth: '196px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: { xs: '12px', sm: '14px' },
    '&:hover': {
      backgroundColor: 'primary.main',
      color: 'info.light',
    },
  },
}
export default LinkBtn
